var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjects24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1500 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e8dcff;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 750,
    cy: 504.97,
    r: 335.69
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "objects") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bubble_4",
    "data-name": "bubble 4"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 750,
    cy: 504.97,
    r: 335.69
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M732.6,360.06c7.53,23.36,28.79,39.13,48.84,53.29l60,42.36c18.62,13.15,38.45,26.76,61.17,28.57,35.61,2.84,68.63-26.65,76.91-61.41,15-63.21-43.27-146-106-160.25C817.4,249.86,707.88,283.38,732.6,360.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M891.16,595.29c-16.33,4.54-27.44,21.93-26.54,38.85s12.62,32.32,27.94,39.56,33.62,6.85,49.5.91c25.92-9.69,46-35.51,45.54-63.18s-23.74-54.07-51.4-54.85-53.24,27.51-47,54.47"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjects24);
export default __webpack_public_path__ + "static/media/objects-24.6d6220ebcda26ff0de1205b6d7dc0f85.svg";
export { ForwardRef as ReactComponent };